export const CLIENTS_QUERY_KEY = ["clients"] as const;
export const clientsQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
  tagPublicId?: string;
}) => [...CLIENTS_QUERY_KEY, params] as const;
export const CLIENT_TAGS_QUERY_KEY = ["clientTags"] as const;
export const CLIENT_PROFILE_QUERY_KEY = ["client", "profile"] as const;
export const clientProfileQueryKey = (publicId: string) =>
  [...CLIENT_PROFILE_QUERY_KEY, publicId] as const;
export const CLIENTS_TAG_ASSIGNMENT_QUERY_KEY = [
  "clients",
  "tagAssignment",
] as const;
export const clientsTagAssignmentQueryKey = (params: {
  tagPublicId: string;
  tagStatus: string;
  search?: string;
  subscriptionHistory?: string;
  planPublicIds?: string;
  limit: number;
  offset: number;
}) => [...CLIENTS_TAG_ASSIGNMENT_QUERY_KEY, params] as const;

export const CLIENTS_APP_STATUS_QUERY_KEY = ["clients", "appStatus"] as const;
export const clientsAppStatusQueryKey = (params: {
  search?: string;
  appStatus?: string;
  subscriptionStatus?: string;
  sortBy?: string;
  sortDirection?: string;
  limit?: number;
  offset?: number;
}) => [...CLIENTS_APP_STATUS_QUERY_KEY, params] as const;
export const FOOD_ITEMS_QUERY_KEY = ["foodItems"] as const;
export const foodItemsQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
  supplierPublicId?: string;
}) => [...FOOD_ITEMS_QUERY_KEY, params] as const;
export const MERCHANDISE_ITEMS_QUERY_KEY = ["merchandiseItems"] as const;
export const merchandiseItemsQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
  supplierPublicId?: string;
}) => [...MERCHANDISE_ITEMS_QUERY_KEY, params] as const;
export const MACHINERY_QUERY_KEY = ["machinery"] as const;
export const maintenanceRecordsQueryKey = (
  machineryPublicId: string,
  page: number = 1,
) => [...MACHINERY_QUERY_KEY, "maintenance", machineryPublicId, page] as const;

export const maintenanceRecordsBaseQueryKey = (machineryPublicId: string) =>
  [...MACHINERY_QUERY_KEY, "maintenance", machineryPublicId] as const;
export const PLATFORM_EXPENSES_QUERY_KEY = [
  "admin",
  "platformExpenses",
] as const;
export const platformExpensesQueryKey = (page: number, month: string) =>
  [...PLATFORM_EXPENSES_QUERY_KEY, month, page] as const;
export const platformExpensesSummaryQueryKey = (month: string) =>
  [...PLATFORM_EXPENSES_QUERY_KEY, "summary", month] as const;
export const ADMIN_GATEWAY_TRANSACTIONS_QUERY_KEY = [
  "admin",
  "gatewayTransactions",
] as const;
export const adminGatewayTransactionsSummaryQueryKey = (month: string) =>
  [...ADMIN_GATEWAY_TRANSACTIONS_QUERY_KEY, "summary", month] as const;
export const ADMIN_MAIL_USAGE_QUERY_KEY = ["admin", "mailUsage"] as const;
export const adminMailUsageQueryKey = (month: string) =>
  [...ADMIN_MAIL_USAGE_QUERY_KEY, month] as const;
export const ADMIN_APP_BANNERS_QUERY_KEY = ["admin", "appBanners"] as const;
export const adminAppBannersQueryKey = (status: string, page: number) =>
  [...ADMIN_APP_BANNERS_QUERY_KEY, status, page] as const;
export const ADMIN_APP_RELEASES_QUERY_KEY = ["admin", "appReleases"] as const;
export const adminAppReleasesQueryKey = (page: number) =>
  [...ADMIN_APP_RELEASES_QUERY_KEY, "list", page] as const;
export const adminAppReleaseDetailQueryKey = (
  publicId: string,
  status: string,
  page: number,
) => [...ADMIN_APP_RELEASES_QUERY_KEY, publicId, status, page] as const;
export const adminAppReleaseGymsQueryKey = () =>
  [...ADMIN_APP_RELEASES_QUERY_KEY, "gyms"] as const;
export const adminAppReleaseAudienceQueryKey = (params: {
  gymPublicIds: string[];
  version: string;
  search: string;
  page: number;
}) => [...ADMIN_APP_RELEASES_QUERY_KEY, "audience", params] as const;
export const PLATFORM_EXPENSE_TEMPLATES_QUERY_KEY = [
  "admin",
  "platformExpenseTemplates",
] as const;
export const PLATFORM_PLANS_QUERY_KEY = ["admin", "platformPlans"] as const;
export const platformPlansQueryKey = (params: { active?: boolean }) =>
  [...PLATFORM_PLANS_QUERY_KEY, params] as const;
export const MAIL_TEST_TYPES_QUERY_KEY = ["admin", "mailTestTypes"] as const;
export const GYM_SUBSCRIPTIONS_QUERY_KEY = [
  "admin",
  "gymSubscriptions",
] as const;
export const gymSubscriptionsQueryKey = (page: number) =>
  [...GYM_SUBSCRIPTIONS_QUERY_KEY, page] as const;
export const GYM_SUBSCRIPTIONS_SUMMARY_QUERY_KEY = [
  ...GYM_SUBSCRIPTIONS_QUERY_KEY,
  "summary",
] as const;
export const gymSalesQueryKey = (filters: Record<string, unknown>) =>
  [...GYM_SUBSCRIPTIONS_QUERY_KEY, "sales", filters] as const;
export const gymSubscriptionDetailQueryKey = (gymPublicId: string) =>
  [...GYM_SUBSCRIPTIONS_QUERY_KEY, "detail", gymPublicId] as const;
export const EXPENSES_QUERY_KEY = ["expenses"] as const;
export const MONTHLY_EXPENSE_METRICS_QUERY_KEY = [
  "monthly-expense-metrics",
] as const;
export const EXPENSES_QUERY_KEYS = {
  all: [...EXPENSES_QUERY_KEY] as const,
  recent: () => [...EXPENSES_QUERY_KEYS.all, "recent"] as const,
  historical: (page: number, params: Record<string, unknown>) =>
    [...EXPENSES_QUERY_KEYS.all, "historical", page, params] as const,
};
export const SUBSCRIPTIONS_QUERY_KEY = ["subscriptions"] as const;
export const subscriptionDetailQueryKey = (publicId: string) =>
  [...SUBSCRIPTIONS_QUERY_KEY, "detail", publicId] as const;
export const subscriptionHistoryQueryKey = (publicId: string) =>
  [...SUBSCRIPTIONS_QUERY_KEY, "history", publicId] as const;
export const subscriptionHistoryPageQueryKey = (
  publicId: string,
  page: number,
  pageSize: number,
) => [...subscriptionHistoryQueryKey(publicId), { page, pageSize }] as const;
export const PLANS_QUERY_KEY = ["plans"] as const;
export const plansQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
  createsSubscription?: boolean;
  active?: boolean;
}) => [...PLANS_QUERY_KEY, params] as const;
export const PLAN_CATEGORIES_QUERY_KEY = ["plans", "categories"] as const;
export const INVENTORY_QUERY_KEY = ["inventory"] as const;
export const INVENTORY_BY_ITEM_QUERY_KEY = (
  itemType: "food" | "merchandise",
  itemPublicId: string,
) => ["inventory", itemType, itemPublicId] as const;
export const LOW_STOCK_ITEMS_QUERY_KEY = ["lowStockItems"] as const;
export const inventoryMovementsQueryKey = (inventoryPublicId: string) =>
  ["inventory", inventoryPublicId, "movements"] as const;
export const ACTIVITY_LOGS_QUERY_KEY = ["activityLogs"] as const;
export const activityLogsQueryKey = (
  limit: number,
  offset: number,
  filters: Record<string, unknown>,
  refreshKey: number,
) => [...ACTIVITY_LOGS_QUERY_KEY, limit, offset, refreshKey, filters] as const;
export const GYMS_QUERY_KEY = ["gyms"] as const;
export const USERS_QUERY_KEY = ["users"] as const;
export const ADMIN_USERS_QUERY_KEY = ["admin", "users"] as const;
export const GYM_EMAIL_CONFIG_QUERY_KEY = [
  "admin",
  "gym",
  "emailConfig",
] as const;
export const GYM_EXPENSES_CONFIG_QUERY_KEY = [
  "admin",
  "gym",
  "expensesConfig",
] as const;
export const gymModulesConfigQueryKey = (gymPublicId: string) =>
  ["admin", "gym", "modulesConfig", gymPublicId] as const;
export const gymBusinessTypeQueryKey = (gymPublicId: string) =>
  ["admin", "gym", "businessType", gymPublicId] as const;
export const gymClientFieldsConfigQueryKey = (gymPublicId: string) =>
  ["admin", "gym", "clientFieldsConfig", gymPublicId] as const;
export const PAYMENT_METHODS_QUERY_KEY = ["paymentMethods"] as const;
export const PAYMENT_METHOD_PRESETS_QUERY_KEY = [
  "admin",
  "paymentMethodPresets",
] as const;
export const EXPENSE_TEMPLATES_QUERY_KEY = ["expenseTemplates"] as const;
export const OTHER_INCOME_CATEGORIES_QUERY_KEY = [
  "otherIncomeCategories",
] as const;
export const OTHER_INCOMES_QUERY_KEY = ["otherIncomes"] as const;
export const UNIFIED_INCOMES_QUERY_KEY = ["unifiedIncomes"] as const;
export const LAST_TICKET_NUMBER_QUERY_KEY = ["lastTicketNumber"] as const;
export const DAILY_SALES_QUERY_KEY = ["daily-sales"] as const;
export const USER_CONFIG_QUERY_KEY = ["user", "config"] as const;
export const USER_PROFILE_QUERY_KEY = ["user", "profile"] as const;

export const PLAN_PAYMENTS_QUERY_KEYS = ["planPayments"] as const;

export const FOOD_PAYMENTS_QUERY_KEYS = ["foodPayments"] as const;

export const MERCHANDISE_PAYMENTS_QUERY_KEYS = ["merchandisePayments"] as const;

export const ACCESS_CONTROL_QUERY_KEYS = {
  all: ["accessControl"] as const,
  search: (query: string) =>
    [...ACCESS_CONTROL_QUERY_KEYS.all, "search", query] as const,
  activeClients: (page: number, date?: string) =>
    [
      ...ACCESS_CONTROL_QUERY_KEYS.all,
      "activeClients",
      page,
      date ?? "today",
    ] as const,
  exceptions: () => [...ACCESS_CONTROL_QUERY_KEYS.all, "exceptions"] as const,
  clientLogs: (clientPublicId: string, page: number) =>
    [
      ...ACCESS_CONTROL_QUERY_KEYS.all,
      "clientLogs",
      clientPublicId,
      page,
    ] as const,
  faceDescriptors: () =>
    [...ACCESS_CONTROL_QUERY_KEYS.all, "faceDescriptors"] as const,
};

export const TRAINERS_QUERY_KEY = ["trainers"] as const;
export const trainersQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
}) => [...TRAINERS_QUERY_KEY, params] as const;
export const TRAINER_PROFILE_QUERY_KEY = ["trainer", "profile"] as const;
export const trainerProfileQueryKey = (publicId: string, page: number) =>
  [...TRAINER_PROFILE_QUERY_KEY, publicId, page] as const;
export const TRAINER_RATES_QUERY_KEY = ["trainer", "rates"] as const;
export const trainerRatesQueryKey = (publicId: string) =>
  [...TRAINER_RATES_QUERY_KEY, publicId] as const;
export const TRAINER_PAYMENT_SUMMARY_QUERY_KEY = [
  "trainer",
  "payment-summary",
] as const;
export const trainerPaymentSummaryQueryKey = (month: string) =>
  [...TRAINER_PAYMENT_SUMMARY_QUERY_KEY, month] as const;

export const SHIFTS_QUERY_KEY = ["shifts"] as const;
export const shiftsQueryKey = (
  startDate: string,
  endDate: string,
  staffPublicId?: string,
) =>
  [
    ...SHIFTS_QUERY_KEY,
    "list",
    startDate,
    endDate,
    staffPublicId ?? "all",
  ] as const;
export const SHIFT_PAY_SUMMARY_QUERY_KEY = [
  ...SHIFTS_QUERY_KEY,
  "pay-summary",
] as const;
export const shiftPaySummaryQueryKey = (startDate: string, endDate: string) =>
  [...SHIFT_PAY_SUMMARY_QUERY_KEY, startDate, endDate] as const;
export const SHIFT_STAFF_QUERY_KEY = [...SHIFTS_QUERY_KEY, "staff"] as const;

export const TAX_METRICS_QUERY_KEY = ["tax-metrics"] as const;
export const taxMetricsQueryKey = (yearMonth: string) =>
  [...TAX_METRICS_QUERY_KEY, yearMonth] as const;

export const BOOKINGS_QUERY_KEY = ["bookings"] as const;
export const bookingsQueryKey = (start: string, end: string) =>
  [...BOOKINGS_QUERY_KEY, start, end] as const;
export const classSessionsQueryKey = (start: string, end: string) =>
  [...BOOKINGS_QUERY_KEY, "classes", start, end] as const;
export const TEMPLATE_BLOCKS_QUERY_KEY = [
  ...BOOKINGS_QUERY_KEY,
  "template-blocks",
] as const;
export const HOLIDAYS_QUERY_KEY = [...BOOKINGS_QUERY_KEY, "holidays"] as const;
export const holidaysQueryKey = (from: string, to: string) =>
  [...HOLIDAYS_QUERY_KEY, from, to] as const;
export const ELIGIBLE_CLIENTS_QUERY_KEY = ["eligibleClients"] as const;
export const eligibleClientsQueryKey = (search: string, classDate: string) =>
  [...ELIGIBLE_CLIENTS_QUERY_KEY, search, classDate] as const;

export const checkpointPinStatusQueryKey = (gymPublicId: string) =>
  ["checkpoint-pin-status", gymPublicId] as const;
export const gymGatewayConfigQueryKey = (gymPublicId: string) =>
  ["admin", "gym", "gatewayConfig", gymPublicId] as const;

export const MANAGER_GATEWAY_CONFIG_QUERY_KEY = [
  "gym",
  "gatewayConfig",
] as const;

export const GYM_APP_CATALOG_QUERY_KEY = ["gym", "appCatalog"] as const;

export const GYM_APP_BANNERS_QUERY_KEY = ["gym", "appBanners"] as const;

export const GATEWAY_TRANSACTIONS_QUERY_KEY = ["gatewayTransactions"] as const;

export const GATEWAY_SUBSCRIPTIONS_QUERY_KEY = [
  "gatewaySubscriptions",
] as const;
export const gatewaySubscriptionDetailQueryKey = (publicId: string) =>
  [...GATEWAY_SUBSCRIPTIONS_QUERY_KEY, "detail", publicId] as const;

export const PLAN_SYNC_QUERY_KEY = ["planSync"] as const;
export const planSyncStatusQueryKey = (planPublicId: string) =>
  [...PLAN_SYNC_QUERY_KEY, "status", planPublicId] as const;
export const syncedPlansQueryKey = (provider?: string) =>
  [...PLAN_SYNC_QUERY_KEY, "list", provider ?? "all"] as const;

export const CLIENT_FREQUENCY_QUERY_KEY = ["client-frequency"] as const;

export const MATERIALS_QUERY_KEY = ["materials"] as const;
export const materialsQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
}) => [...MATERIALS_QUERY_KEY, params] as const;
export const materialMovementsQueryKey = (materialPublicId: string) =>
  [...MATERIALS_QUERY_KEY, "movements", materialPublicId] as const;

export const SALES_ORDERS_QUERY_KEY = ["salesOrders"] as const;
export const salesOrdersQueryKey = (params: Record<string, unknown>) =>
  [...SALES_ORDERS_QUERY_KEY, params] as const;
export const salesOrderDetailQueryKey = (publicId: string) =>
  [...SALES_ORDERS_QUERY_KEY, "detail", publicId] as const;
export const salesOrderPdfQueryKey = (publicId: string) =>
  [...SALES_ORDERS_QUERY_KEY, "pdf", publicId] as const;

export const INVOICES_QUERY_KEY = ["invoices"] as const;
export const invoicesQueryKey = (params: Record<string, unknown>) =>
  [...INVOICES_QUERY_KEY, params] as const;
export const invoiceDetailQueryKey = (publicId: string) =>
  [...INVOICES_QUERY_KEY, "detail", publicId] as const;
export const invoicePdfQueryKey = (publicId: string) =>
  [...INVOICES_QUERY_KEY, "pdf", publicId] as const;

export const PRODUCTION_METRICS_QUERY_KEY = ["production-metrics"] as const;

export const B2B_CRM_QUERY_KEY = ["b2bCrm"] as const;
export const b2bCrmQueryKey = (params: Record<string, unknown>) =>
  [...B2B_CRM_QUERY_KEY, params] as const;
export const B2B_CRM_CLIENT_IDS_QUERY_KEY = [
  ...B2B_CRM_QUERY_KEY,
  "clientIds",
] as const;

export const PLATFORM_METRICS_QUERY_KEY = ["admin", "platformMetrics"] as const;

export const SUPPLIERS_QUERY_KEY = ["suppliers"] as const;
export const suppliersQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
}) => [...SUPPLIERS_QUERY_KEY, params] as const;
export const supplierStatsQueryKey = (publicId: string, month: string) =>
  [...SUPPLIERS_QUERY_KEY, "stats", publicId, month] as const;

export const PRODUCTS_QUERY_KEY = ["products"] as const;
export const productsQueryKey = (params: {
  search?: string;
  limit?: number;
  offset?: number;
  active?: boolean;
}) => [...PRODUCTS_QUERY_KEY, params] as const;
export const productDetailQueryKey = (publicId: string) =>
  [...PRODUCTS_QUERY_KEY, "detail", publicId] as const;
export const productRecipeQueryKey = (publicId: string) =>
  [...PRODUCTS_QUERY_KEY, "recipe", publicId] as const;

export const NOTIFICATIONS_QUERY_KEY = ["notifications"] as const;
export const notificationsQueryKey = (params: Record<string, unknown>) =>
  [...NOTIFICATIONS_QUERY_KEY, params] as const;
export const NOTIFICATION_UNREAD_COUNT_QUERY_KEY = [
  "notifications",
  "unreadCount",
] as const;

// Raíz distinta de ["notifications"]: al cambiar de rol no se arrastra caché
// de la bandeja del rol anterior.
export const PLATFORM_NOTIFICATIONS_QUERY_KEY = [
  "platformNotifications",
] as const;
export const platformNotificationsQueryKey = (
  params: Record<string, unknown>,
) => [...PLATFORM_NOTIFICATIONS_QUERY_KEY, params] as const;
export const PLATFORM_NOTIFICATION_UNREAD_COUNT_QUERY_KEY = [
  "platformNotifications",
  "unreadCount",
] as const;

export const CAMPAIGN_HISTORY_QUERY_KEY = ["campaign-history"] as const;
export const campaignDetailQueryKey = (publicId: string) =>
  ["campaign", "detail", publicId] as const;

export const ONBOARDING_STATUS_QUERY_KEY = ["onboarding-status"] as const;

/** Una versión publicada es inmutable: se cachea por su id, nunca por tipo. */
export const legalDocumentQueryKey = (versionPublicId: string) =>
  ["legal", "document", versionPublicId] as const;

export const LEGAL_HISTORY_QUERY_KEY = ["legal", "history"] as const;
export const LEGAL_ACCEPTANCES_QUERY_KEY = ["legal", "acceptances"] as const;

export const legalDocumentHistoryQueryKey = (type: string, page: number) =>
  [...LEGAL_HISTORY_QUERY_KEY, type, page] as const;

export const legalAcceptancesQueryKey = (
  filters: {
    documentType: string;
    version: number | null;
    gymPublicId: string | null;
  },
  page: number,
) =>
  [
    ...LEGAL_ACCEPTANCES_QUERY_KEY,
    filters.documentType,
    filters.version,
    filters.gymPublicId,
    page,
  ] as const;

export const CLIENT_METRICS_QUERY_KEY = ["client-metrics"] as const;
export const clientMetricsSeriesQueryKey = (months: number) =>
  [...CLIENT_METRICS_QUERY_KEY, "series", months] as const;
export const clientMetricsMonthQueryKey = (yearMonth: string) =>
  [...CLIENT_METRICS_QUERY_KEY, "month", yearMonth] as const;

export const BILLING_QUERY_KEY = ["billing"] as const;
export const billingStatusQueryKey = () =>
  [...BILLING_QUERY_KEY, "status"] as const;
export const billingProvidersQueryKey = () =>
  [...BILLING_QUERY_KEY, "providers"] as const;
export const billingInvoicesQueryKey = (page: number) =>
  [...BILLING_QUERY_KEY, "invoices", page] as const;
